import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import AnimatedLoadingIcon from "@core/layouts/components/Loading.vue";

import axios from "axios"; //如果需要axios，请引入

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour"; 

// Print
import VueHtmlToPaper from "vue-html-to-paper";

import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);

window.axios = axios;

// Axios Mock Adapter
import "@/@fake-db/db";

// # Instruct Vue to use it
/* import LaravelPermissionToVueJS from "laravel-permission-to-vuejs";
Vue.use(LaravelPermissionToVueJS); */

// Prefered: as a plugin (directive + filter) + custom placeholders support
/* import VueMask from 'v-mask'
Vue.use(VueMask); */

var token = localStorage.getItem("token") ? localStorage.getItem("token") : "";
var baseUrl = "https://api.spprf.org/api/";

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

var myApi = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});
// Interceptor begin
myApi.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

myApi.interceptors.response.use(
  function (response) {
    console.log("---Interceptor response ---");
    // console.log(response);
    // Any status code within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    console.log(error);
    console.log(error.response);
    
    // if (error.response.status == 401 || error.response.status == undefined && error.response.status != null) {
    if (error.response.status == 401) {
      // session expired
      // console.log(error);
      // Remove userData from localStorage
      // deconnect

      // Remove userData from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
      localStorage.removeItem("userLoggedIn");

      // console.log(router);

      // Redirect to login page
      localStorage.setItem("last_route_name", window.location.href);
      router.push({ name: "auth-login" });
      // console.log(", query: { 'redirect': route.name }");
    }

    // Any status codes outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
// Interceptor end
// export default api
window.myApiBaseUrl = baseUrl;
window.myApi = myApi;

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// set default permissions
// window.Laravel.jsPermissions = [];
/* console.log('window.Laravel');
console.log(window.Laravel); */
var special_permissions = localStorage.getItem("special_permissions")
  ? localStorage.getItem("special_permissions")
  : [];
window.vueSpatiePermissions = special_permissions;

// loading icon global registration
Vue.component('AnimatedLoadingIcon', AnimatedLoadingIcon);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

// printing
// or, using the defaults with no stylesheet

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false;

if(window.location.pathname === "/" || window.location.pathname === "" || window.location.pathname === null || window.location.pathname === undefined){
  
  if(localStorage.getItem("userData")==null || localStorage.getItem("userData")=="null"){
    // no userData
     // Remove userData from localStorage
     localStorage.removeItem("userData");
     localStorage.removeItem("token");
     localStorage.removeItem("userLoggedIn");

    router.push({ name: "auth-login" });
  }else{
    // go to dashboard
    window.location = "/dashboard/default"
  }

}

var vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  beforeCreate:function(){
    console.log("Before create vuejs app... perform get config")
  }
}).$mount("#app");

// export default instance;
